export enum TariffTypeEnum {
    Standard = 0,
    Premium = 1,
    Individual = 2
}
